export const trimItemName = (strn) => {
  if (strn?.trim()?.split(" ")?.length >= 3) {
    let itemName = strn?.trim()?.split(" ");
    itemName?.shift();
    return itemName?.join(" ");
  } else {
    return strn;
  }
};
